import Reflux from 'reflux';
import ResizingTextareaActions from 'flux/actions/cuesheet/ResizingTextareaActions';
import { Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';

/**
 * Resizing Text Area Store...maintain height state
 *
 */
export default Reflux.createStore({
  listenables: [ResizingTextareaActions],

  mixins: [BaseMixin],

  init() {
    this.setState(Map());
  },

  onSetHeight(height) {
    this.setInStateAndTrigger('height', height);
  },

  onClearHeight() {
    this.setStateAndTrigger(this.getState().delete('height'));
  },
});
